module.exports = {"350429100":"杉城镇","350429101":"朱口镇","350429200":"新桥乡","350429201":"上青乡","350429202":"大田乡","350429203":"梅口乡","350429204":"下渠乡","350429205":"开善乡","350429208":"大龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350429.json
// module id = 1195
// module chunks = 0